import { Ridgeline } from '../../components/illustrations';
import { greeting } from '../../lib/time';
import styles from './BoardHeader.module.css';
import { FEED_REACH } from '../../../shared/region';

interface Props {
  place: string;
  title?: string;
  subtitle?: string;
}

export function BoardHeader({ place, title, subtitle }: Props) {
  return (
    <header className={styles.sign}>
      <h1 className={styles.greeting}>{title ?? `${greeting()}, ${place}.`}</h1>
      <p className={styles.sub}>{subtitle ?? `Notes from neighbors within ${FEED_REACH} of home, newest first.`}</p>
      <div className={styles.ridge}>
        <Ridgeline height={40} />
      </div>
    </header>
  );
}
